import {League} from "./League";
import {IApiLadder} from "../typings/apiResponse";

/**
 * @ngdoc overview
 *
 * @type {Object}
 * @name ngLeague.Ladder
 *
 * @requires apiResponse
 *
 * @description
 * The ladder object represents a Ladder on ESL Play. It can be build using an API response for a Ladder cup directly or by
 * calling the factory method in {@link ngLeague.League}.
 */
export class Ladder extends League {
    constructor(private apiResponse: IApiLadder) {
        super(apiResponse);
    }

    public getMaxOpenMatches() {
        return this.apiResponse.maxOpenMatches;
    }

    public getState(): string {
        return this.apiResponse.state;
    }
}
